import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { SLINKY } from 'HubStyleTokens/colors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
import breakpoint from 'ui-addon-upgrades/_core/utils/responsiveBreakpoints';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
const FooterWrapper = styled.div.withConfig({
  displayName: "FooterMicrocopy__FooterWrapper",
  componentId: "kvkwyc-0"
})(["position:relative;padding-top:16px;padding-bottom:20px;z-index:1;color:", ";font-size:12px;clear:both;", ""], SLINKY, breakpoint.tablet(_t || (_t = _`
    padding-left: 25px;
    padding-right: 30px;
  `)));

const FooterMicrocopy = () => {
  const handleClickLink = () => {
    tracker.track('externalLinkClick', {
      name: 'product-services-catalog'
    });
  };

  return /*#__PURE__*/_jsx(FooterWrapper, {
    className: "text-center flex-column",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "upgrades.productCatalog.footer.productServicesCatalogPrompt_jsx",
      options: {
        onClick: handleClickLink
      },
      elements: {
        UILink
      }
    })
  });
};

export default FooterMicrocopy;